import jQuery from 'jquery';

jQuery(function($) {
  let $asides = $('.aside');

  $asides.each(function() {
    let $aside = $(this);

    let $dropdowns = $aside.find('.aside__dropdown_opener');
    $dropdowns.each(function() {
      let $dropdownOpener = $(this);
      let $dropdownList = $aside.find('.aside__dropdown_list--' + $dropdownOpener.data('dropdown'));

      $dropdownOpener.on('click', function() {
        if ($dropdownOpener.attr('href') !== 'javascript:void(0);') {
          return;
        }

        if ($dropdownOpener.hasClass('aside__link--active')) {
          $dropdownList.slideUp(300);
        } else {
          $dropdownList.slideDown(300);
        }
        $dropdownOpener.toggleClass('aside__link--active');
      });

      if ($dropdownOpener.hasClass('aside__link--active')) {
        $dropdownList.slideDown(0);
      } else {
        $dropdownList.slideUp(0);
      }
    });
  });
});
